import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

const MobileConfirmationTable = () => 
    <Table aria-label="customized table" style={{ width: 710 }}>
          <TableHead sx={{ width: 710 }}>
            <TableRow>
              <StyledTableCell style={{fontSize:16, width: 60}}>Parameter</StyledTableCell>
              <StyledTableCell style={{fontSize:16, width: 650}}>Explanation</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody> 
            <StyledTableRow key={"status"}>
              <StyledTableCell>status</StyledTableCell>
              <StyledTableCell>Status of process</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow key={"transactionId"}>
              <StyledTableCell>transactionId</StyledTableCell>
              <StyledTableCell>The ID will be used to complete process</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow key={"authenticationType"}>
              <StyledTableCell>authenticationType</StyledTableCell>
              <StyledTableCell>authenticationType value will be 5 for Mobile Confirmation Flow. </StyledTableCell>
            </StyledTableRow>
            <StyledTableRow key={"activationId"}>
              <StyledTableCell>activationId</StyledTableCell>
              <StyledTableCell>it only returns in mobile confirmation response. It is passed in request when calling the Execute service. </StyledTableCell>
            </StyledTableRow>
            <StyledTableRow key={"requestId"}>
              <StyledTableCell>requestId</StyledTableCell>
              <StyledTableCell>it only returns in mobile confirmation response. It is passed in request when calling the Execute service.</StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>;

export default MobileConfirmationTable;
